export default  {
  template: require('../views/period.cheatsheet.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/base/components/period.cheatsheet.component.js